import { render, staticRenderFns } from "./SolicitudDetail.vue?vue&type=template&id=292d3a86"
import script from "./SolicitudDetail.vue?vue&type=script&lang=js"
export * from "./SolicitudDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports